<article class="flex flex-col gap-6">
  <img
    alt="Logo by Courthouse Computer Systems"
    class="w-15 h-15 object-contain"
    src="assets/loader-logo.png" />

  <div>
    <p class="text-sm text-gray-500">
      Clerk of Circuit Court, {{ court().name }}
    </p>
    <h2 class="text-base font-bold text-[#353C40] mt-1">Reservation Page</h2>
  </div>

  <div class="flex flex-col gap-3 text-sm text-[#1A1A1A99]">
    <div class="flex items-center gap-2">
      <fa-icon [icon]="faClock" class="text-[#1A1A1A99]" />
      <span>1 hour</span>
    </div>
  </div>
  <p class="text-sm text-[#353C40] leading-relaxed">
    Appointment Scheduling use this section to schedule an appointment with the
    appropriate authority related to your case.
  </p>
  <p class="text-sm text-[#353C40] leading-relaxed">
    Select an available date and time, review the appointment details, and save
    your selection.
  </p>
</article>
